import {
  concat, filter, flatten, forEach, get, includes, isEmpty, isNull, map, min, reject, uniq, uniqBy,
} from 'lodash';
import moment from 'moment';
import React, { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import PreOrderSelection from '../components/preOrderSelection';
import { DATA_SOURCE, FILTER } from '../constants';
import menuContext from '../contexts/menu';

export default ({ data, onProductClick }) => {
  const { menuCache } = useContext(menuContext);
  const { fridgeId: selectedFridgeId } = useParams();
  const {
    currentMenuArrangementDaily, dailyFreshPreOrderDates, onlineShopDates, fridges,
  } = menuCache || {};

  const dateToDisplay = useMemo(() => {
    const currentMoment = moment().utcOffset(8);
    const currentDate = currentMoment.format('YYYYMMDD');
    const moment930 = currentMoment.clone().set({ h: 9, m: 30 });
    const datesToCal = uniq(concat(dailyFreshPreOrderDates || [], onlineShopDates || []));

    if (moment().isBefore(moment930)) {
      if (includes(datesToCal, currentDate)) {
        return currentDate;
      }
    }

    return min(reject(datesToCal, (date) => date === currentDate), currentDate);
  }, [dailyFreshPreOrderDates, onlineShopDates]);

  const preOrderSelectionIds = useMemo(() => uniq(flatten(map(
    filter(currentMenuArrangementDaily, ({ startTime, endTime }) => moment().isBetween(startTime, endTime, undefined, '[]')),
    'productIds'
  ))), [currentMenuArrangementDaily]);

  const products = useMemo(() => {
    const result = [];
    forEach(preOrderSelectionIds, (id) => {
      const Item = data.find((item) => item.id === id && item.dataSource !== DATA_SOURCE.MENU);
      const { dataSource, filterDict } = Item || {};
      if (get(filterDict, [FILTER.BESTSELLER], false)) return;

      const latestRegisterTime = get(
        Item,
        ['redeemDateLatestRegisterTimeDict', dateToDisplay],
        null
      );
      const redeemStartTime = +moment(dateToDisplay)
        .utcOffset(8)
        .startOf('day')
        .set('hour', 12);
      const arrangedDate = get(
        Item,
        ['redeemDateArrangedDateDict', dateToDisplay],
        null
      );
      if (
        isNull(latestRegisterTime)
        || isNull(redeemStartTime)
        || moment(latestRegisterTime).isBefore()
        || !includes(preOrderSelectionIds, id)
      ) return;

      if (dataSource === DATA_SOURCE.DAILY_FRESH_PRE_ORDER) {
        if (isNull(arrangedDate)) return;

        Item.arrangedTime = +moment(arrangedDate).utcOffset(8).startOf('day');
      }
      Item.fridgeId = selectedFridgeId;
      Item.fridgeName = get(fridges, [selectedFridgeId, 'name']);
      Item.redeemStartTime = redeemStartTime;
      Item.redeemEndTime = +moment(redeemStartTime)
        .utcOffset(8)
        .startOf('day')
        .add(1, 'day')
        .set('hour', 11);
      result.push(Item);
    });
    return result;
  }, [data, dateToDisplay, preOrderSelectionIds, selectedFridgeId, fridges]);

  const onMoreButtonClick = () => {
    const menuFilter = document.getElementById('menu-filter');

    if (menuFilter) {
      document.getElementById('root').scrollTo({
        top: menuFilter.getBoundingClientRect().top - 110,
        behavior: 'smooth',
      });
    }
  };

  const uniqueProducts = useMemo(() => uniqBy(products, 'id'), [products]);

  return (isEmpty(uniqueProducts)
    ? null
    : (
      <PreOrderSelection
        dateString={dateToDisplay}
        onMoreButtonClick={onMoreButtonClick}
        onProductClick={onProductClick}
        products={uniqueProducts}
      />
    )
  );
};
